export function MinusIcon({ className }: { className?: string }) {
  return (
    <svg
      width="12"
      height="2"
      viewBox="0 0 12 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="12" y="2" width="12" height="2" transform="rotate(-180 12 2)" fill="#F7941D"/>
    </svg>
  );
}
